<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false" >
        <template #title>
          <strong>修改密码</strong>
        </template>
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.replace('/me')"></span>
        </template>
      </van-nav-bar>
    </van-sticky>
    <div class="form">
      <div class="form-item">
        <div class="label">手机号</div>
        <div class="input"><input :value="userInfo.username" type="number" disabled placeholder="请输入手机号" ></div>
      </div>
        <div class="form-item">
          <div class="label">验证码</div>
          <div class="input">
            <input v-model="code" type="text" maxlength="6" placeholder="请输入短信验证码" >
            <div v-if="countNum === 60" class="code active" @click="sendSms">发送验证码</div>
            <div v-else class="code">{{ countNum }}s 重新发送</div>
          </div>
        </div>
      <div class="form-item">
        <div class="label">密码</div>
        <div class="input"><input v-model="password" type="password" placeholder="请输入密码(至少8位)" ></div>
      </div>
      <van-button :loading="loading" loading-text="加载中..." color="#FC3159" :disabled="!isActive" class="login-btn mt-24 border-radius" @click="resetPwd">保存修改</van-button>
    </div>
  </div>
</template>

<script>
import { smsSend, resetPwd } from '@/api/common.js'
import md5 from 'js-md5'
import { mapState } from 'vuex'
export default {
  name: 'ResetPwd',
  data() {
    return {
      loading: false,
      countNum: 60,
      timer: null,
      mobile: '',
      code: '',
      password: ''
    }
  },
  computed: {
    isActive() {
      return this.code && this.password.length >= 8 && true || false
    },
    ...mapState(['userInfo'])
  },
  methods: {
    countNumAuto() { // 倒计时
      this.countNum--;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.countNum--;
        if (this.countNum < 1) {
          clearInterval(this.timer);
          this.countNum = 60;
        }
      }, 1000)
    },
    async sendSms() {
      this.countNumAuto()
      try {
        const res = await smsSend({ mobile: this.userInfo.username, event: 'resetpwd' })
        this.$toast.success(res.msg)
      } catch {
        clearInterval(this.timer)
        this.countNum = 60
      }
    },
    async resetPwd() {
      this.loading = true
      try {
        const res = await resetPwd({ mobile: this.userInfo.username, code: this.code, newpassword: md5(this.password) })
        if (res.code === 1) {
          this.$toast.success(res.msg)
          setTimeout(async () => {
            await this.$store.dispatch('logout')
            this.$router.push('/login')
          }, 2000)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/form.scss';
.form{
  padding-bottom: 20px;
  margin-top: 0;
  color: #0D0E15;
  .input{
    input{
      font-size:   14px;
      color: #0D0E15;
    }
  }
}
</style>
